module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/cover-4-597c1c8fdb78734d18bd2ed0b89e2948.webp";